import React, { useEffect, useCallback } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { confirmPasswordReset } from "../../../redux/auth/actions";
import { clearSpecificRequest } from "../../../redux/request/action";
import { CONFIRM_PASSWORD_RESET } from "../../../redux/auth/actionType";
import { validation } from "../../../constants";
import { ResetPassword } from "../../templates/ResetPassword";
import { Alert } from "../../atoms/Alert";

import { useQueryData } from '../../../hooks/common';

const ResetPasswordPage = () => {
  const dispatch = useDispatch();
  const queryData = useQueryData();
  const history = useHistory();
  const request = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[CONFIRM_PASSWORD_RESET],
  );

  const dispatchConfirmPasswordReset = useCallback(
    (form: { password: string }) =>
      dispatch(confirmPasswordReset(queryData?.oobCode, form.password)),
    [dispatch, queryData]
  );

  useEffect(() => {
    if (request?.didSucceed && !request?.isLoading) {
      setTimeout(() => { history.push("/login"); }, 2000);
    }
  }, [history, request]);

  useEffect(() => {
    dispatch(clearSpecificRequest(CONFIRM_PASSWORD_RESET));
  }, [dispatch])

  const validate = (values: any) => {
    const errors: any = {};

    if (!values.password) {
      errors.password = "Please enter your new password!";
    } else if (!validation.passwordValidation.test(values.password)) {
      errors.password =
        "Provide at least 8 characters, 1 lowercase, 1 uppercase character, 1 number or special character.";
    }

    if (values.confirm_password !== values.password) {
      errors.confirm_password = "Password does not match";
    }

    return errors;
  };

  return (
    <>
      <ResetPassword
        onSubmit={dispatchConfirmPasswordReset}
        isLoading={request?.isLoading}
        validate={validate}
      />
      {(request?.didSucceed) && (
          <Alert
            type="success"
            message="Successfully changed password. You will be redirected to login"
            showIcon
          />
      )}
      {(request?.error) && <Alert type="error" message={request?.error} showIcon />}
    </>
  );
};

export default ResetPasswordPage;
